import React, { useState, useEffect } from 'react';
import { ref, get, update, push, runTransaction } from 'firebase/database';
import { db } from '../../firebase/config';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCheck,
  FaSpinner,
  FaCalendarAlt,
  FaUserPlus
} from 'react-icons/fa';

// ---------------- Indian States and Districts Data ----------------
const statesAndDistricts = {
  'Andaman and Nicobar Islands': ['Nicobar', 'North and Middle Andaman', 'South Andaman'],
  'Andhra Pradesh': [
    'Anantapur',
    'Chittoor',
    'East Godavari',
    'Guntur',
    'Krishna',
    'Kurnool',
    'Nellore',
    'Prakasam',
    'Srikakulam',
    'Visakhapatnam',
    'Vizianagaram',
    'West Godavari',
    'YSR Kadapa'
  ],
  Arunachal_Pradesh: [
    'Anjaw',
    'Changlang',
    'Dibang Valley',
    'East Kameng',
    'East Siang',
    'Kamle',
    'Kra Daadi',
    'Kurung Kumey',
    'Lepa Rada',
    'Lohit',
    'Longding',
    'Lower Dibang Valley',
    'Lower Siang',
    'Lower Subansiri',
    'Namsai',
    'Pakke Kessang',
    'Papum Pare',
    'Shi Yomi',
    'Siang',
    'Tawang',
    'Tirap',
    'Upper Siang',
    'Upper Subansiri',
    'West Kameng',
    'West Siang'
  ],
  Assam: [
    'Baksa',
    'Barpeta',
    'Biswanath',
    'Bongaigaon',
    'Cachar',
    'Charaideo',
    'Chirang',
    'Darrang',
    'Dhemaji',
    'Dhubri',
    'Dibrugarh',
    'Dima Hasao',
    'Goalpara',
    'Golaghat',
    'Hailakandi',
    'Hojai',
    'Jorhat',
    'Kamrup',
    'Kamrup Metropolitan',
    'Karbi Anglong',
    'Karimganj',
    'Kokrajhar',
    'Lakhimpur',
    'Majuli',
    'Morigaon',
    'Nagaon',
    'Nalbari',
    'Sivasagar',
    'Sonitpur',
    'South Salmara-Mankachar',
    'Tinsukia',
    'Udalguri',
    'West Karbi Anglong'
  ],
  Bihar: [
    'Araria',
    'Arwal',
    'Aurangabad',
    'Banka',
    'Begusarai',
    'Bhagalpur',
    'Bhojpur',
    'Buxar',
    'Darbhanga',
    'East Champaran',
    'Gaya',
    'Gopalganj',
    'Jamui',
    'Jehanabad',
    'Kaimur',
    'Katihar',
    'Khagaria',
    'Kishanganj',
    'Lakhisarai',
    'Madhepura',
    'Madhubani',
    'Munger',
    'Muzaffarpur',
    'Nalanda',
    'Nawada',
    'Patna',
    'Purnia',
    'Rohtas',
    'Saharsa',
    'Samastipur',
    'Saran',
    'Sheikhpura',
    'Sheohar',
    'Sitamarhi',
    'Siwan',
    'Supaul',
    'Vaishali',
    'West Champaran'
  ],
  Chandigarh: ['Chandigarh'],
  Chhattisgarh: [
    'Balod',
    'Baloda Bazar',
    'Balrampur',
    'Bastar',
    'Bemetara',
    'Bijapur',
    'Bilaspur',
    'Dantewada',
    'Dhamtari',
    'Durg',
    'Gariaband',
    'Gaurela Pendra Marwahi',
    'Janjgir Champa',
    'Jashpur',
    'Kabirdham',
    'Kanker',
    'Kondagaon',
    'Korba',
    'Koriya',
    'Mahasamund',
    'Mungeli',
    'Narayanpur',
    'Raigarh',
    'Raipur',
    'Rajnandgaon',
    'Sukma',
    'Surajpur',
    'Surguja'
  ],
  'Dadra and Nagar Haveli and Daman and Diu': ['Dadra and Nagar Haveli', 'Daman', 'Diu'],
  Delhi: [
    'Central Delhi',
    'East Delhi',
    'New Delhi',
    'North Delhi',
    'North East Delhi',
    'North West Delhi',
    'Shahdara',
    'South Delhi',
    'South East Delhi',
    'South West Delhi',
    'West Delhi'
  ],
  Goa: ['North Goa', 'South Goa'],
  Gujarat: [
    'Ahmedabad',
    'Amreli',
    'Anand',
    'Aravalli',
    'Banaskantha',
    'Bharuch',
    'Bhavnagar',
    'Botad',
    'Chhota Udaipur',
    'Dahod',
    'Dang',
    'Devbhoomi Dwarka',
    'Gandhinagar',
    'Gir Somnath',
    'Jamnagar',
    'Junagadh',
    'Kheda',
    'Kutch',
    'Mahisagar',
    'Mehsana',
    'Morbi',
    'Narmada',
    'Navsari',
    'Panchmahal',
    'Patan',
    'Porbandar',
    'Rajkot',
    'Sabarkantha',
    'Surat',
    'Surendranagar',
    'Tapi',
    'Vadodara',
    'Valsad'
  ],
  Haryana: [
    'Ambala',
    'Bhiwani',
    'Charkhi Dadri',
    'Faridabad',
    'Fatehabad',
    'Gurugram',
    'Hisar',
    'Jhajjar',
    'Jind',
    'Kaithal',
    'Karnal',
    'Kurukshetra',
    'Mahendragarh',
    'Nuh',
    'Palwal',
    'Panchkula',
    'Panipat',
    'Rewari',
    'Rohtak',
    'Sirsa',
    'Sonipat',
    'Yamunanagar'
  ],
  'Himachal Pradesh': [
    'Bilaspur',
    'Chamba',
    'Hamirpur',
    'Kangra',
    'Kinnaur',
    'Kullu',
    'Lahaul and Spiti',
    'Mandi',
    'Shimla',
    'Sirmaur',
    'Solan',
    'Una'
  ],
  'Jammu and Kashmir': [
    'Anantnag',
    'Bandipora',
    'Baramulla',
    'Budgam',
    'Doda',
    'Ganderbal',
    'Jammu',
    'Kathua',
    'Kishtwar',
    'Kulgam',
    'Kupwara',
    'Poonch',
    'Pulwama',
    'Rajouri',
    'Ramban',
    'Reasi',
    'Samba',
    'Shopian',
    'Srinagar',
    'Udhampur'
  ],
  Jharkhand: [
    'Bokaro',
    'Chatra',
    'Deoghar',
    'Dhanbad',
    'Dumka',
    'East Singhbhum',
    'Garhwa',
    'Giridih',
    'Godda',
    'Gumla',
    'Hazaribagh',
    'Jamtara',
    'Khunti',
    'Koderma',
    'Latehar',
    'Lohardaga',
    'Pakur',
    'Palamu',
    'Ramgarh',
    'Ranchi',
    'Sahebganj',
    'Seraikela Kharsawan',
    'Simdega',
    'West Singhbhum'
  ],
  Karnataka: [
    'Bagalkot',
    'Ballari',
    'Belagavi',
    'Bengaluru Rural',
    'Bengaluru Urban',
    'Bidar',
    'Chamarajanagar',
    'Chikkaballapur',
    'Chikkamagaluru',
    'Chitradurga',
    'Dakshina Kannada',
    'Davanagere',
    'Dharwad',
    'Gadag',
    'Hassan',
    'Haveri',
    'Kalaburagi',
    'Kodagu',
    'Kolar',
    'Koppal',
    'Mandya',
    'Mysuru',
    'Raichur',
    'Ramanagara',
    'Shivamogga',
    'Tumakuru',
    'Udupi',
    'Uttara Kannada',
    'Vijayapura',
    'Yadgir'
  ],
  Kerala: [
    'Alappuzha',
    'Ernakulam',
    'Idukki',
    'Kannur',
    'Kasaragod',
    'Kollam',
    'Kottayam',
    'Kozhikode',
    'Malappuram',
    'Palakkad',
    'Pathanamthitta',
    'Thiruvananthapuram',
    'Thrissur',
    'Wayanad'
  ],
  Ladakh: ['Kargil', 'Leh'],
  Lakshadweep: ['Lakshadweep'],
  'Madhya Pradesh': [
    'Agar Malwa',
    'Alirajpur',
    'Anuppur',
    'Ashoknagar',
    'Balaghat',
    'Barwani',
    'Betul',
    'Bhind',
    'Bhopal',
    'Burhanpur',
    'Chhatarpur',
    'Chhindwara',
    'Damoh',
    'Datia',
    'Dewas',
    'Dhar',
    'Dindori',
    'Guna',
    'Gwalior',
    'Harda',
    'Hoshangabad',
    'Indore',
    'Jabalpur',
    'Jhabua',
    'Katni',
    'Khandwa',
    'Khargone',
    'Mandla',
    'Mandsaur',
    'Morena',
    'Narsinghpur',
    'Neemuch',
    'Niwari',
    'Panna',
    'Raisen',
    'Rajgarh',
    'Ratlam',
    'Rewa',
    'Sagar',
    'Satna',
    'Sehore',
    'Seoni',
    'Shahdol',
    'Shajapur',
    'Sheopur',
    'Shivpuri',
    'Sidhi',
    'Singrauli',
    'Tikamgarh',
    'Ujjain',
    'Umaria',
    'Vidisha'
  ],
  Maharashtra: [
    'Ahmednagar',
    'Akola',
    'Amravati',
    'Aurangabad',
    'Beed',
    'Bhandara',
    'Buldhana',
    'Chandrapur',
    'Dhule',
    'Gadchiroli',
    'Gondia',
    'Hingoli',
    'Jalgaon',
    'Jalna',
    'Kolhapur',
    'Latur',
    'Mumbai City',
    'Mumbai Suburban',
    'Nagpur',
    'Nanded',
    'Nandurbar',
    'Nashik',
    'Osmanabad',
    'Palghar',
    'Parbhani',
    'Pune',
    'Raigad',
    'Ratnagiri',
    'Sangli',
    'Satara',
    'Sindhudurg',
    'Solapur',
    'Thane',
    'Wardha',
    'Washim',
    'Yavatmal'
  ],
  Manipur: [
    'Bishnupur',
    'Chandel',
    'Churachandpur',
    'Imphal East',
    'Imphal West',
    'Jiribam',
    'Kakching',
    'Kamjong',
    'Kangpokpi',
    'Noney',
    'Pherzawl',
    'Senapati',
    'Tamenglong',
    'Tengnoupal',
    'Thoubal',
    'Ukhrul'
  ],
  Meghalaya: [
    'East Garo Hills',
    'East Jaintia Hills',
    'East Khasi Hills',
    'North Garo Hills',
    'Ri Bhoi',
    'South Garo Hills',
    'South West Garo Hills',
    'South West Khasi Hills',
    'West Garo Hills',
    'West Jaintia Hills',
    'West Khasi Hills'
  ],
  Mizoram: [
    'Aizawl',
    'Champhai',
    'Hnahthial',
    'Kolasib',
    'Khawzawl',
    'Lawngtlai',
    'Lunglei',
    'Mamit',
    'Saiha',
    'Saitual',
    'Serchhip'
  ],
  Nagaland: [
    'Chumukedima',
    'Dimapur',
    'Kiphire',
    'Kohima',
    'Longleng',
    'Mokokchung',
    'Mon',
    'Niuland',
    'Noklak',
    'Peren',
    'Phek',
    'Shamator',
    'Tseminyu',
    'Tuensang',
    'Wokha',
    'Zunheboto'
  ],
  Odisha: [
    'Angul',
    'Balangir',
    'Balasore',
    'Bargarh',
    'Bhadrak',
    'Boudh',
    'Cuttack',
    'Deogarh',
    'Dhenkanal',
    'Gajapati',
    'Ganjam',
    'Jagatsinghpur',
    'Jajpur',
    'Jharsuguda',
    'Kalahandi',
    'Kandhamal',
    'Kendrapara',
    'Kendujhar',
    'Khordha',
    'Koraput',
    'Malkangiri',
    'Mayurbhanj',
    'Nabarangpur',
    'Nayagarh',
    'Nuapada',
    'Puri',
    'Rayagada',
    'Sambalpur',
    'Subarnapur',
    'Sundargarh'
  ],
  Puducherry: ['Karaikal', 'Mahe', 'Puducherry', 'Yanam'],
  Punjab: [
    'Amritsar',
    'Barnala',
    'Bathinda',
    'Faridkot',
    'Fatehgarh Sahib',
    'Fazilka',
    'Ferozepur',
    'Gurdaspur',
    'Hoshiarpur',
    'Jalandhar',
    'Kapurthala',
    'Ludhiana',
    'Malerkotla',
    'Mansa',
    'Moga',
    'Mohali',
    'Muktsar',
    'Pathankot',
    'Patiala',
    'Rupnagar',
    'Sangrur',
    'Shaheed Bhagat Singh Nagar',
    'Tarn Taran'
  ],
  Rajasthan: [
    'Ajmer',
    'Alwar',
    'Banswara',
    'Baran',
    'Barmer',
    'Bharatpur',
    'Bhilwara',
    'Bikaner',
    'Bundi',
    'Chittorgarh',
    'Churu',
    'Dausa',
    'Dholpur',
    'Dungarpur',
    'Hanumangarh',
    'Jaipur',
    'Jaisalmer',
    'Jalore',
    'Jhalawar',
    'Jhunjhunu',
    'Jodhpur',
    'Karauli',
    'Kota',
    'Nagaur',
    'Pali',
    'Pratapgarh',
    'Rajsamand',
    'Sawai Madhopur',
    'Sikar',
    'Sirohi',
    'Sri Ganganagar',
    'Tonk',
    'Udaipur'
  ],
  Sikkim: ['East Sikkim', 'North Sikkim', 'Pakyong', 'Soreng', 'South Sikkim', 'West Sikkim'],
  'Tamil Nadu': [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivaganga',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar'
  ],
  Telangana: [
    'Adilabad',
    'Bhadradri Kothagudem',
    'Hyderabad',
    'Jagtial',
    'Jangaon',
    'Jayashankar',
    'Jogulamba',
    'Kamareddy',
    'Karimnagar',
    'Khammam',
    'Komaram Bheem',
    'Mahabubabad',
    'Mahbubnagar',
    'Mancherial',
    'Medak',
    'Medchal Malkajgiri',
    'Mulugu',
    'Nagarkurnool',
    'Nalgonda',
    'Narayanpet',
    'Nirmal',
    'Nizamabad',
    'Peddapalli',
    'Rajanna Sircilla',
    'Rangareddy',
    'Sangareddy',
    'Siddipet',
    'Suryapet',
    'Vikarabad',
    'Wanaparthy',
    'Warangal Rural',
    'Warangal Urban',
    'Yadadri Bhuvanagiri'
  ],
  Tripura: [
    'Dhalai',
    'Gomati',
    'Khowai',
    'North Tripura',
    'Sepahijala',
    'South Tripura',
    'Unakoti',
    'West Tripura'
  ],
  'Uttar Pradesh': [
    'Agra',
    'Aligarh',
    'Ambedkar Nagar',
    'Amethi',
    'Amroha',
    'Auraiya',
    'Ayodhya',
    'Azamgarh',
    'Baghpat',
    'Bahraich',
    'Ballia',
    'Balrampur',
    'Banda',
    'Barabanki',
    'Bareilly',
    'Basti',
    'Bhadohi',
    'Bijnor',
    'Budaun',
    'Bulandshahr',
    'Chandauli',
    'Chitrakoot',
    'Deoria',
    'Etah',
    'Etawah',
    'Farrukhabad',
    'Fatehpur',
    'Firozabad',
    'Gautam Buddha Nagar',
    'Ghaziabad',
    'Ghazipur',
    'Gonda',
    'Gorakhpur',
    'Hamirpur',
    'Hapur',
    'Hardoi',
    'Hathras',
    'Jalaun',
    'Jaunpur',
    'Jhansi',
    'Kannauj',
    'Kanpur Dehat',
    'Kanpur Nagar',
    'Kasganj',
    'Kaushambi',
    'Kheri',
    'Kushinagar',
    'Lalitpur',
    'Lucknow',
    'Maharajganj',
    'Mahoba',
    'Mainpuri',
    'Mathura',
    'Mau',
    'Meerut',
    'Mirzapur',
    'Moradabad',
    'Muzaffarnagar',
    'Pilibhit',
    'Pratapgarh',
    'Prayagraj',
    'Raebareli',
    'Rampur',
    'Saharanpur',
    'Sambhal',
    'Sant Kabir Nagar',
    'Shahjahanpur',
    'Shamli',
    'Shravasti',
    'Siddharthnagar',
    'Sitapur',
    'Sonbhadra',
    'Sultanpur',
    'Unnao',
    'Varanasi'
  ],
  Uttarakhand: [
    'Almora',
    'Bageshwar',
    'Chamoli',
    'Champawat',
    'Dehradun',
    'Haridwar',
    'Nainital',
    'Pauri',
    'Pithoragarh',
    'Rudraprayag',
    'Tehri',
    'Udham Singh Nagar',
    'Uttarkashi'
  ],
  'West Bengal': [
    'Alipurduar',
    'Bankura',
    'Birbhum',
    'Cooch Behar',
    'Dakshin Dinajpur',
    'Darjeeling',
    'Hooghly',
    'Howrah',
    'Jalpaiguri',
    'Jhargram',
    'Kalimpong',
    'Kolkata',
    'Malda',
    'Murshidabad',
    'Nadia',
    'North 24 Parganas',
    'Paschim Bardhaman',
    'Paschim Medinipur',
    'Purba Bardhaman',
    'Purba Medinipur',
    'Purulia',
    'South 24 Parganas',
    'Uttar Dinajpur'
  ]
};

const RegisterTrainingUsers = () => {
  const [trainings, setTrainings] = useState([]);
  const [selectedTraining, setSelectedTraining] = useState('');
  const [selectedTrainingData, setSelectedTrainingData] = useState(null);
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [availableDistricts, setAvailableDistricts] = useState([]);

  const [participant, setParticipant] = useState({
    name: '',
    mobile: '',
    email: '',
    dateOfBirth: '',
    referredBy: '',
    address: '',
    state: '',
    city: '',
    pin: ''
  });

  // manual Razorpay fields
  const [manualPayment, setManualPayment] = useState({
    razorpayPaymentId: '',
    razorpayOrderId: '',
    razorpaySignature: '',
    amountPaid: ''
  });

  // ---------------- Validation ----------------
  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s]+$/;
    if (!name) return 'Name is required';
    if (name.length < 2) return 'Name must be at least 2 characters long';
    if (name.length > 50) return 'Name must not exceed 50 characters';
    if (!nameRegex.test(name)) return 'Name can only contain letters and spaces';
    if (/\s{2,}/.test(name)) return 'Name cannot have multiple consecutive spaces';
    return '';
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobile) return 'Mobile number is required';
    if (!/^\d+$/.test(mobile)) return 'Mobile number can only contain digits';
    if (!mobileRegex.test(mobile)) return 'Enter a valid 10-digit Indian mobile number starting with 6-9';
    return '';
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return 'Email is required';
    if (email.length > 100) return 'Email must not exceed 100 characters';
    if (!emailRegex.test(email)) return 'Enter a valid email address';
    if (email !== email.toLowerCase()) return 'Email should be in lowercase';
    return '';
  };

  const validateDateOfBirth = (dob) => {
    if (!dob) return 'Date of birth is required';
    const selectedDate = new Date(dob);
    const today = new Date();
    const age = today.getFullYear() - selectedDate.getFullYear();
    const monthDiff = today.getMonth() - selectedDate.getMonth();

    if (selectedDate > today) return 'Date of birth cannot be in the future';
    if (age < 16 || (age === 16 && monthDiff < 0)) return 'Must be at least 16 years old';
    if (age > 100) return 'Please enter a valid date of birth';
    return '';
  };

  const validateAddress = (address) => {
    const addressRegex = /^[a-zA-Z0-9 ,.\-]+$/;
    if (!address) return 'Address is required';
    if (address.length < 10) return 'Address must be at least 10 characters long';
    if (address.length > 200) return 'Address must not exceed 200 characters';
    if (!addressRegex.test(address)) return 'Address contains invalid characters';
    if (/\s{2,}/.test(address)) return 'Address cannot have multiple consecutive spaces';
    return '';
  };

  const validateCity = (city) => {
    if (!city) return 'District is required';
    return '';
  };

  const validateState = (state) => {
    if (!state) return 'State is required';
    return '';
  };

  const validatePin = (pin) => {
    const pinRegex = /^\d{6}$/;
    if (!pin) return 'PIN code is required';
    if (!/^\d+$/.test(pin)) return 'PIN code can only contain digits';
    if (!pinRegex.test(pin)) return 'Enter a valid 6-digit PIN code';
    if (pin.startsWith('0')) return 'PIN code cannot start with 0';
    return '';
  };

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        return validateName(value);
      case 'mobile':
        return validateMobile(value);
      case 'email':
        return validateEmail(value);
      case 'dateOfBirth':
        return validateDateOfBirth(value);
      case 'address':
        return validateAddress(value);
      case 'city':
        return validateCity(value);
      case 'state':
        return validateState(value);
      case 'pin':
        return validatePin(value);
      default:
        return '';
    }
  };

  // ---------------- Fetch trainings ----------------
  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        const snap = await get(ref(db, 'HTAMS/company/trainings'));
        if (snap.exists()) {
          const data = snap.val();
          const trainingList = Object.keys(data)
            .map((key) => ({
              id: key,
              ...data[key]
            }))
            .filter((training) => {
              if (training.expireDate) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const expireDate = new Date(training.expireDate);
                expireDate.setHours(0, 0, 0, 0);
                return today <= expireDate;
              }
              if (training.expiresAt && Date.now() > training.expiresAt) {
                return false;
              }
              return true;
            });
          setTrainings(trainingList);
        }
      } catch (error) {
        console.error('Error fetching trainings:', error);
        setMessage('Error loading trainings. Please try again.');
      }
    };

    fetchTrainings();
  }, []);

  // ---------------- Input change ----------------
  // Handle training selection change
  const handleTrainingChange = async (trainingId) => {
    setSelectedTraining(trainingId);
    
    if (!trainingId) {
      setSelectedTrainingData(null);
      setManualPayment(prev => ({ ...prev, amountPaid: '' }));
      return;
    }
    
    try {
      const trainingRef = ref(db, `HTAMS/company/trainings/${trainingId}`);
      const trainingSnap = await get(trainingRef);
      if (trainingSnap.exists()) {
        const trainingData = trainingSnap.val();
        setSelectedTrainingData(trainingData);
        
        // Auto-populate amount paid with training fees if available
        if (trainingData.fees) {
          setManualPayment(prev => ({
            ...prev,
            amountPaid: String(trainingData.fees)
          }));
        } else {
          setManualPayment(prev => ({ ...prev, amountPaid: '' }));
        }
      }
    } catch (error) {
      console.error('Error fetching training details:', error);
      setMessage('Error loading training details. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;

    switch (name) {
      case 'name':
        processedValue = value
          .replace(/[^a-zA-Z\s]/g, '')
          .replace(/\s{2,}/g, ' ');
        break;

      case 'mobile':
        processedValue = value.replace(/\D/g, '').slice(0, 10);
        break;

      case 'email':
        processedValue = value.toLowerCase().trim();
        break;

      case 'pin':
        processedValue = value.replace(/\D/g, '').slice(0, 6);
        break;

      case 'address':
        processedValue = value
          .replace(/[^a-zA-Z0-9 ,.\-]/g, '')
          .replace(/\s{2,}/g, '  ');
        break;

      case 'state':
        processedValue = value;
        if (value && statesAndDistricts[value]) {
          setAvailableDistricts(statesAndDistricts[value]);
        } else {
          setAvailableDistricts([]);
        }
        setParticipant((prev) => ({ ...prev, state: value, city: '' }));
        break;

      case 'city':
        processedValue = value;
        break;

      case 'dateOfBirth':
        processedValue = value;
        break;

      default:
        break;
    }

    if (name !== 'state') {
      setParticipant((prev) => ({ ...prev, [name]: processedValue }));
    }

    const error = validateField(name, processedValue);
    setFieldErrors((prev) => ({ ...prev, [name]: error }));
  };

  // ---------------- Email exists check ----------------
  const checkEmailExists = async (email) => {
    const emailKey = email.toLowerCase().replace(/\./g, ',');
    try {
      const snap = await get(ref(db, `HTAMS/emails/${emailKey}`));
      if (snap.exists()) {
        setMessage('This email is already registered.');
        return true;
      }
      return false;
    } catch {
      setMessage('Error checking email. Please try again.');
      return true;
    }
  };

  // ---------------- Submit: manual successful online-like registration ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    if (!selectedTraining) {
      setMessage('Please select a training program.');
      setIsSubmitting(false);
      return;
    }

    const requiredFields = [
      'name',
      'mobile',
      'email',
      'dateOfBirth',
      'address',
      'city',
      'state',
      'pin'
    ];

    let hasErrors = false;
    const newFieldErrors = {};
    for (const field of requiredFields) {
      const error = validateField(field, participant[field]);
      if (error) {
        newFieldErrors[field] = error;
        hasErrors = true;
      }
    }

    setFieldErrors(newFieldErrors);

    if (hasErrors) {
      setMessage('Please fix all field errors before proceeding.');
      setIsSubmitting(false);
      return;
    }

    // validate manual payment fields
    const amountPaidNumber = Number(manualPayment.amountPaid);
    if (
      !manualPayment.razorpayPaymentId.trim() ||
      !manualPayment.razorpayOrderId.trim() ||
      !manualPayment.razorpaySignature.trim() ||
      Number.isNaN(amountPaidNumber) ||
      amountPaidNumber <= 0
    ) {
      setMessage('Please enter all manual Razorpay payment details correctly.');
      setIsSubmitting(false);
      return;
    }

    setMessage('Checking if email is already registered...');
    if (await checkEmailExists(participant.email)) {
      setIsSubmitting(false);
      return;
    }

    try {
      const trainingRef = ref(
        db,
        `HTAMS/company/trainings/${selectedTraining}`
      );
      const trainingSnap = await get(trainingRef);
      if (!trainingSnap.exists()) {
        setMessage('Selected training not found or invalid.');
        setIsSubmitting(false);
        return;
      }
      const trainingData = trainingSnap.val();

      // slot check & increment joinedCount
      let canJoin = false;
      await runTransaction(trainingRef, (data) => {
        if (data) {
          if ((data.joinedCount || 0) >= (data.candidates || 0)) return undefined;
          return { ...data, joinedCount: (data.joinedCount || 0) + 1 };
        }
        return data;
      }).then((r) => {
        canJoin = r.committed;
      });

      if (!canJoin) {
        setMessage('All slots are filled for this training.');
        setIsSubmitting(false);
        return;
      }

      // Build paymentDetails EXACTLY like successful online JoinTraining
      const paymentDetails = {
        razorpay_payment_id: manualPayment.razorpayPaymentId.trim(),
        razorpay_order_id: manualPayment.razorpayOrderId.trim(),
        razorpay_signature: manualPayment.razorpaySignature.trim(),
        payment_status: 'success',
        payment_timestamp: Date.now(),
        amount_paid: amountPaidNumber,
        currency: 'INR',
        training_id: selectedTraining,
        payment_method: 'online',
        verified: true,
        captured: true
      };

      const pKey = push(
        ref(db, `HTAMS/company/trainings/${selectedTraining}/participants`)
      ).key;
      const emailKey = participant.email.toLowerCase().replace(/\./g, ',');

      const currentDate = new Date();
      const joiningDate = currentDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });

      const cleanedAddress = participant.address.trim().replace(/\s{2,}/g, ' ');

      const newParticipant = {
        name: participant.name,
        mobile: participant.mobile,
        email: participant.email,
        dateOfBirth: participant.dateOfBirth,
        referredBy: participant.referredBy || '',
        address: cleanedAddress,
        city: participant.city,
        state: participant.state,
        pin: participant.pin,
        trainingId: selectedTraining,
        joinedAt: Date.now(),
        joiningDate: joiningDate,
        status: 'joined',
        confirmedByTrainer: true,
        confirmedAt: new Date().toISOString(),
        confirmedBy: 'manual_online_payment',
        formMode: 'user',
        userAccountCreated: false,
        paymentDetails: paymentDetails,
        feePaid: paymentDetails.amount_paid,
        paymentStatus: 'completed'
      };

      const updates = {};
      updates[
        `HTAMS/company/trainings/${selectedTraining}/participants/${pKey}`
      ] = newParticipant;
      updates[`HTAMS/emails/${emailKey}`] = {
        trainingId: selectedTraining,
        type: 'training',
        timestamp: Date.now()
      };
      updates[`HTAMS/company/trainings/${selectedTraining}/updatedAt`] =
        Date.now();

      await update(ref(db), updates);

      setMessage(
        `✅ Manual registration successful! ${participant.name} has been registered with successful payment.`
      );

      setParticipant({
        name: '',
        mobile: '',
        email: '',
        dateOfBirth: '',
        referredBy: '',
        address: '',
        city: '',
        state: '',
        pin: ''
      });
      setManualPayment({
        razorpayPaymentId: '',
        razorpayOrderId: '',
        razorpaySignature: '',
        amountPaid: ''
      });
      setSelectedTraining('');
      setFieldErrors({});
      setAvailableDistricts([]);
      setIsSubmitting(false);
    } catch (error) {
      console.error('Registration error:', error);
      setMessage('Failed to register participant. Please try again.');
      setIsSubmitting(false);
    }
  };

  // ---------------- JSX ----------------
  return (
    <div className="register-training-users-container">
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .register-training-users-container {
          font-family: 'Inter', sans-serif;
         
        
          min-height: 100vh;
          max-width: 100%;
          margin: 0 auto;
        }

        .page-header {
          text-align: center;
          margin-bottom: 24px;
          padding: 24px 20px;
          background: var(--mobile-bg-primary);
       
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
        }

        .page-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: var(--mobile-text-primary);
          margin: 0 0 8px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }

        .title-icon {
          color: var(--mobile-text-primary);
          font-size: 1.6rem;
        }

        .page-subtitle {
          color: var(--mobile-text-secondary);
          font-size: 1rem;
          margin: 0;
        }

        .registration-form {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
          padding: 24px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
        }

        .form-section {
          margin-bottom: 24px;
        }

        .section-title {
          font-size: 1.2rem;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 16px 0;
          padding-bottom: 10px;
          border-bottom: 2px solid #f1f5f9;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .section-icon {
          color: #6366f1;
        }

        .form-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }

        @media (min-width: 768px) {
          .form-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .form-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .form-group.full-width {
          grid-column: 1 / -1;
        }

        .form-label {
          font-weight: 600;
          color: #334155;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .label-icon {
          color: #6366f1;
          font-size: 0.85rem;
        }

        .form-input,
        .form-select {
          padding: 12px 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: white;
          color: #1e293b;
        }

        .form-input:focus,
        .form-select:focus {
          outline: none;
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .form-input.error,
        .form-select.error {
          border-color: #ef4444;
        }

        .error-message {
          color: #dc2626;
          font-size: 0.8rem;
          font-weight: 500;
          margin-top: 2px;
        }

        .submit-button {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          border: none;
          padding: 16px 32px;
          border-radius: 16px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 24px;
          box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
          width: 100%;
        }

        .submit-button:hover:not(.disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
        }

        .submit-button.disabled {
          background: #94a3b8;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .notification {
          padding: 16px 20px;
          margin-top: 20px;
          border-radius: 16px;
          font-weight: 600;
          text-align: center;
          animation: slideIn 0.3s ease-out;
          font-size: 0.95rem;
        }

        .notification.success {
          background: rgba(240, 253, 244, 0.95);
          color: #15803d;
          border: 2px solid #22c55e;
          backdrop-filter: blur(10px);
        }

        .notification.error {
          background: rgba(254, 242, 242, 0.95);
          color: #dc2626;
          border: 2px solid #ef4444;
          backdrop-filter: blur(10px);
        }

        .notification.info {
          background: rgba(240, 249, 255, 0.95);
          color: #0369a1;
          border: 2px solid #0ea5e9;
          backdrop-filter: blur(10px);
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div className="page-header">
        <h1 className="page-title">
          <FaUserPlus className="title-icon" />
          Register Training Users (Manual Paid)
        </h1>
        <p className="page-subtitle">
          Use this only when Razorpay payment is already successful but user is not registered.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="registration-form">
        {/* Training Selection */}
        <div className="form-section">
          <h3 className="section-title">
            <FaCalendarAlt className="section-icon" />
            Select Training Program
          </h3>
          <div className="form-grid">
            <div className="form-group full-width">
              <label className="form-label">Training Program *</label>
              <select
                value={selectedTraining}
                onChange={(e) => handleTrainingChange(e.target.value)}
                required
                className="form-input"
              >
                <option value="">Select a training program</option>
                {trainings.map((training) => (
                  <option key={training.id} value={training.id}>
                    {training.location} - {training.startDate} - ₹{training.fees || '0'} (
                    {(training.candidates || 0) - (training.joinedCount || 0)} slots)
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Personal Information */}
        <div className="form-section">
          <h3 className="section-title">
            <FaUser className="section-icon" />
            Personal Information
          </h3>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">
                <FaUser className="label-icon" />
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter full name"
                value={participant.name}
                onChange={handleChange}
                required
                className={`form-input ${fieldErrors.name ? 'error' : ''}`}
              />
              {fieldErrors.name && (
                <div className="error-message">{fieldErrors.name}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                <FaPhone className="label-icon" />
                Mobile Number *
              </label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter 10-digit mobile number"
                value={participant.mobile}
                onChange={handleChange}
                required
                className={`form-input ${fieldErrors.mobile ? 'error' : ''}`}
              />
              {fieldErrors.mobile && (
                <div className="error-message">{fieldErrors.mobile}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                <FaEnvelope className="label-icon" />
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                value={participant.email}
                onChange={handleChange}
                required
                className={`form-input ${fieldErrors.email ? 'error' : ''}`}
              />
              {fieldErrors.email && (
                <div className="error-message">{fieldErrors.email}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                <FaCalendarAlt className="label-icon" />
                Date of Birth *
              </label>
              <input
                type="date"
                name="dateOfBirth"
                value={participant.dateOfBirth}
                onChange={handleChange}
                required
                className={`form-input ${
                  fieldErrors.dateOfBirth ? 'error' : ''
                }`}
                max={new Date().toISOString().split('T')[0]}
              />
              {fieldErrors.dateOfBirth && (
                <div className="error-message">{fieldErrors.dateOfBirth}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                <FaUser className="label-icon" />
                Referred By
              </label>
              <input
                type="text"
                name="referredBy"
                placeholder="Enter referrer name (optional)"
                value={participant.referredBy}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>
        </div>

        {/* Address Information */}
        <div className="form-section">
          <h3 className="section-title">
            <FaMapMarkerAlt className="section-icon" />
            Address Information
          </h3>
          <div className="form-grid">
            <div className="form-group full-width">
              <label className="form-label">
                <FaMapMarkerAlt className="label-icon" />
                Address *
              </label>
              <input
                type="text"
                name="address"
                placeholder="Enter full address"
                value={participant.address}
                onChange={handleChange}
                required
                className={`form-input ${fieldErrors.address ? 'error' : ''}`}
              />
              {fieldErrors.address && (
                <div className="error-message">{fieldErrors.address}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">State *</label>
              <select
                name="state"
                value={participant.state}
                onChange={handleChange}
                required
                className={`form-input ${fieldErrors.state ? 'error' : ''}`}
              >
                <option value="">Select State</option>
                {Object.keys(statesAndDistricts)
                  .sort()
                  .map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
              </select>
              {fieldErrors.state && (
                <div className="error-message">{fieldErrors.state}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">District *</label>
              <select
                name="city"
                value={participant.city}
                onChange={handleChange}
                required
                disabled={!participant.state}
                className={`form-input ${fieldErrors.city ? 'error' : ''}`}
              >
                <option value="">Select District</option>
                {availableDistricts.map((district) => (
                  <option key={district} value={district}>
                    {district}
                  </option>
                ))}
              </select>
              {fieldErrors.city && (
                <div className="error-message">{fieldErrors.city}</div>
              )}
              {!participant.state && (
                <div className="error-message">Please select state first</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">PIN Code *</label>
              <input
                type="text"
                name="pin"
                placeholder="Enter 6-digit PIN code"
                value={participant.pin}
                onChange={handleChange}
                maxLength="6"
                required
                className={`form-input ${fieldErrors.pin ? 'error' : ''}`}
              />
              {fieldErrors.pin && (
                <div className="error-message">{fieldErrors.pin}</div>
              )}
            </div>
          </div>
        </div>

        {/* Manual Razorpay Payment Details */}
        <div className="form-section">
          <h3 className="section-title">
            <FaCheck className="section-icon" />
            Manual Razorpay Payment Details
          </h3>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Razorpay Payment ID *</label>
              <input
                type="text"
                value={manualPayment.razorpayPaymentId}
                onChange={(e) =>
                  setManualPayment((p) => ({
                    ...p,
                    razorpayPaymentId: e.target.value
                  }))
                }
                placeholder="e.g. pay_Mxyz..."
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Razorpay Order ID *</label>
              <input
                type="text"
                value={manualPayment.razorpayOrderId}
                onChange={(e) =>
                  setManualPayment((p) => ({
                    ...p,
                    razorpayOrderId: e.target.value
                  }))
                }
                placeholder="e.g. order_Mxyz..."
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Razorpay Signature *</label>
              <input
                type="text"
                value={manualPayment.razorpaySignature}
                onChange={(e) =>
                  setManualPayment((p) => ({
                    ...p,
                    razorpaySignature: e.target.value
                  }))
                }
                placeholder="Copy from webhook / dashboard"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Amount Paid (₹) *</label>
              <input
                type="number"
                name="amountPaid"
                placeholder={
                  selectedTrainingData?.fees 
                    ? `Training Fee: ₹${selectedTrainingData.fees}` 
                    : 'Enter amount paid'
                }
                value={manualPayment.amountPaid}
                onChange={(e) =>
                  setManualPayment({
                    ...manualPayment,
                    amountPaid: e.target.value
                  })
                }
                readOnly={!!selectedTraining}
                required
                className={`form-input ${selectedTraining ? 'bg-gray-100' : ''}`}
              />
            </div>
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className={`submit-button ${isSubmitting ? 'disabled' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <FaSpinner className="spinner" />
              Registering with Manual Payment...
            </>
          ) : (
            <>
              <FaCheck />
              Register Participant (Manual Paid)
            </>
          )}
        </button>
      </form>

      {message && (
        <div
          className={`notification ${
            message.toLowerCase().includes('success') ||
            message.includes('✅')
              ? 'success'
              : message.includes('Checking') ||
                message.includes('Registering')
              ? 'info'
              : 'error'
          }`}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default RegisterTrainingUsers;
